// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

/**
 * @deprecated use "@tock/icons" import instead
 * This new package will be where all Icons are imported from going forward
 * You can still use these icons in <IconMigrationUtil /> as the legacy icon
 */
export const SvgIconUser = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: '1em', height: '1em', viewBox: '0 0 24 24', fill: 'none', ...props },
    <path
      d="M12 15.75c3.31 0 6-2.69 6-6s-2.69-6-6-6-6 2.69-6 6 2.69 6 6 6zm0-10.5c2.48 0 4.5 2.02 4.5 4.5s-2.02 4.5-4.5 4.5-4.5-2.02-4.5-4.5 2.02-4.5 4.5-4.5zM24 12c0-6.62-5.38-12-12-12S0 5.38 0 12c0 3.8 1.78 7.18 4.54 9.38.01.01.01.02.02.02.04.04.09.06.13.08 2.03 1.57 4.56 2.51 7.31 2.51s5.28-.94 7.31-2.5c.04-.03.09-.05.13-.09.01-.01.01-.02.02-.02C22.22 19.19 24 15.8 24 12zM1.5 12C1.5 6.21 6.21 1.5 12 1.5S22.5 6.21 22.5 12c0 3.14-1.39 5.95-3.58 7.87A10.54 10.54 0 0012 17.25c-2.54 0-5.02.95-6.92 2.62A10.438 10.438 0 011.5 12zm4.79 8.8A9.076 9.076 0 0112 18.75c2.07 0 4.11.74 5.71 2.05-1.65 1.07-3.61 1.7-5.71 1.7s-4.07-.63-5.71-1.7z"
      fill="currentColor"
    />
  );
export default SvgIconUser;
